import classnames from "classnames";

import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";

import css from "./PlanRow.module.css";

export const PlanRowTrainingSession = () => {
  return (
    <TooltipWrapper toolTip="Add-on Additional customized training sessions for your team and business covering monitoring and incident management best practices!">
      <div className={css.PlanRowHeader}>
        <h2 className={classnames(css.PlanRowHeader, "w-100 text-center fw-semibold fs-5")}>Custom</h2>
        <div className="w-100 text-center px-4">
          <small className="d-block lh-sm fw-light">Training Sessions</small>
        </div>
      </div>
    </TooltipWrapper>
  );
};
